<template>
  <div class="contact-patient">
		<van-cell-group>
			<van-cell title="患者服务" value="" />
			<van-cell class="noticeText"  value="" >{{noticeText}}</van-cell>
			<van-cell title="患者联系方式" >
				<template>
					<div class="mobile_box">
						<div>{{copyText.substring(0,4)}}****{{copyText.substring(8,12)}}</div>
						<van-button class="copy-button" size="mini" type="default" v-clipboard:copy="copyText"  @click="toastText('复制成功!')">复制</van-button>
					</div>
				</template>
			</van-cell>
		</van-cell-group>
		<div class="checkin-btn" v-if="showBottom">
			<van-button @click="go(route)"  type="info" round block color="#0AA8AF">知道了</van-button>
		</div>
	</div>
</template>
<script>
  import Vue from 'vue';
  import {
    mapState
  } from "vuex";
  import {
    Toast,
  } from 'vant';

  Vue.use(Toast);
export default {
	data(){
		return {
			noticeText:'张三',
			copyText:'15523427689',
			showBottom:false,
			route:'',
		}
	},
	created() {
		if(this.$route.query.showBottom) this.showBottom=this.$route.query.showBottom=='true'?true:false
		if(this.$route.query.noticeText) this.noticeText=this.$route.query.noticeText
		if(this.$route.query.copyText) this.copyText=this.$route.query.copyText
		if(this.$route.query.route) this.route=this.$route.query.route
	},
	methods:{
		toastText(text){
			Toast(text)
		},
		go(route){
			console.log("前往:",route)
			if(route=='-1') this.$router.go(-1)
			this.$router.replace({name:route})
		}
	}
};
</script>

<style lang="less" scoped>
.contact-patient {
	font-size: 16px;
  min-height: 100vh;
  background-color: #f9f9f9;
  /* padding: 10px 15px; */
	.noticeText{
		.van-cell__title{
			flex:5;
		}
	}
	.mobile_box{
		display: flex;
		justify-content: flex-end;
		align-items: center; 
	}
	.copy-button{
		margin-left:10px;
		font-size: 14px;
	}
	.checkin-btn {
      margin: 25px;
    }
}
</style>